import { UIRoomUserList } from '../../../../shared/scripts/ui_html/room/UIRoomUserList.ts';
import { showBotEditProfileDialog, showPlayerEditProfileDialog } from '../../../../shared/scripts/ui_popup/edit_profile_dialog/showEditProfileDialog.ts';
import { socket } from '../../../../shared/scripts/EntryShared.ts';
export class UIMRoomUserListController extends UIRoomUserList {
    // eslint-disable-next-line class-methods-use-this
    openEditProfileForPlayer(player) {
        if (player === null || player === void 0 ? void 0 : player.isBot) {
            showBotEditProfileDialog({
                selectColorAction: async (color)=>{
                    if (player == undefined) return;
                    socket.roomClient.selectColor(player.roomSessionId, color);
                },
                selectedColor: player.selectedColor,
                username: player.username
            });
            return;
        }
        showPlayerEditProfileDialog({
            selectColorAction: async (color)=>{
                if (player == undefined) return;
                socket.roomClient.selectColor(player.roomSessionId, color);
            },
            selectedColor: player === null || player === void 0 ? void 0 : player.selectedColor
        });
    }
}
